export default "__VITE_ASSET__25b4ea83__"